var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhattoexpect(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 563.666,
    height: 508.845,
    viewBox: "0 0 563.666 508.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "What_to_expect_",
    "data-name": "What to expect?",
    transform: "translate(-981.194 -3333.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "What_to_expect",
    "data-name": "What to expect",
    transform: "translate(-245.132 1614.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M183.791,33.723c55.3-70.864,151.938-164.086,183.338-122.271S259.836,246.216,222.292,302.9s-80.149,71.833-117.812,63.472-61.216-39.513-45.5-84.605,52.021-44.774,86.943-86.86S128.489,104.587,183.791,33.723Z",
    transform: "translate(1518.448 1721.417) rotate(60)",
    fill: "#6aa5ac"
  }), /*#__PURE__*/React.createElement("text", {
    id: "What_to_expect_2",
    "data-name": "What to expect?",
    transform: "translate(1502.308 2004.961)",
    fill: "#fff",
    fontSize: 55,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -210,
    y: 0
  }, "What to expect?"))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_276_",
    transform: "translate(1049.525 3424.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_274_",
    transform: "translate(258.7 49.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3265_",
    d: "M259.09,96.967l.1-29.957,41.629,24.049-.073,29.933Z",
    transform: "translate(-258.142 -25.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3234_",
    transform: "translate(42.65 34.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3261_",
    d: "M302.664,76.834l-.073,29.933L276.67,91.812,281.655,64.7Z",
    transform: "translate(-275.624 -63.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3262_",
    d: "M303.182,108.72,276.24,93.158,281.565,64.1,304.2,77.158l-.1,31.027ZM278.331,92.185l23.927,13.836.073-27.793-19.38-11.21Z",
    transform: "translate(-276.24 -64.1)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3235_",
    transform: "translate(67.72 19.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3257_",
    d: "M293.132,58.47l22.687,13.106-.073,29.933L286.98,84.78Z",
    transform: "translate(-285.934 -57.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3258_",
    d: "M316.362,103.448,286.55,86.087l6.59-28.207,24.243,14.006-.073,31.027Zm-27.7-18.286,26.748,15.562.073-27.769L294.355,60.749Z",
    transform: "translate(-286.55 -57.88)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1995_",
    d: "M286.421,64.828l-2.991,7.635L299.138,99.43V58.579l-.924-.559Z",
    transform: "translate(-223.296 -38.3)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1989_",
    d: "M274.416,72.323l-2.456,5.909,17.362,25.24V64.809l-.924-.559Z",
    transform: "translate(-239.717 -29.381)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3246_",
    d: "M300.759,114.895,259.13,90.846,329.257,50.36l41.653,24.024-15.222,8.8L333,70.08l-11.039,6.371L343,88.585l-15.222,8.778L306.765,85.229l-13.252,7.635L316.2,105.971Z",
    transform: "translate(-258.084 -49.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_",
    transform: "translate(0.754 7.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M355.593,85.637l15.2-8.8L329.162,52.81,259.01,93.3l41.653,24.049,15.441-8.924L293.417,95.314l5.131-2.967L292.955,88.7l13.982-8.073.924.559v7.2l19.818,11.429,15.2-8.778L321.867,78.9l5.228-3.04L324.2,74.232l-2.821-1.945,11.793-6.808.924.559v7.2Z",
    transform: "translate(-259.01 -52.81)",
    fill: "#6aa5ac"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2032_",
    d: "M329.873,49.91,258.8,90.955l-.1,31.027,42.577,24.584,16.389-9.459.1-31.027L296,93.509l11.38-6.565,20.085,11.6-.1,29.933.948.535,16.146-9.313.073-31L324.451,77.1l9.167-5.3,21.763,12.571-.1,29.933.948.535,16.146-9.313.1-31.027Zm-29.52,93.957-39.781-22.954.073-27.793,38.346,22.152,1.41.827ZM333.618,69.63l-12.912,7.441L341.715,89.2l-13.35,7.708L307.356,84.779l-15.1,8.729,22.687,13.106-13.568,7.83-4.158-2.407-35.6-20.547L329.9,52.074l39.781,22.954-13.349,7.708Z",
    transform: "translate(-258.7 -49.91)",
    fill: "#0c1859"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2077_",
    transform: "translate(266.086 59.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2076_",
    d: "M277.339,76.212c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,277.339,76.212Z",
    transform: "translate(-243.484 -22.37)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2075_",
    d: "M279.879,74.742a.717.717,0,0,1,0,1.362,2.529,2.529,0,0,1-2.359,0,.717.717,0,0,1,0-1.362A2.529,2.529,0,0,1,279.879,74.742Z",
    transform: "translate(-239.848 -24.474)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2074_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(24.784 49.976)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2073_",
    d: "M277.339,73.272c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,277.339,73.272Z",
    transform: "translate(-243.484 -26.579)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2072_",
    d: "M272.249,73.272c.657.389.657,1,0,1.362a2.679,2.679,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,272.249,73.272Z",
    transform: "translate(-250.771 -26.579)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2071_",
    d: "M274.789,71.791c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,274.789,71.791Z",
    transform: "translate(-247.135 -28.673)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2070_",
    d: "M269.7,71.791c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0,.717.717,0,0,1,0-1.362A2.679,2.679,0,0,1,269.7,71.791Z",
    transform: "translate(-254.422 -28.673)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2069_",
    d: "M272.249,70.321c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,272.249,70.321Z",
    transform: "translate(-250.771 -30.777)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2068_",
    d: "M274.789,68.851c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,274.789,68.851Z",
    transform: "translate(-247.135 -32.882)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2067_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(6.182 39.228)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2066_",
    d: "M269.679,68.852a.717.717,0,0,1,0,1.362,2.529,2.529,0,0,1-2.359,0,.717.717,0,0,1,0-1.362A2.529,2.529,0,0,1,269.679,68.852Z",
    transform: "translate(-254.451 -32.907)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2065_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(18.559 32.079)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2064_",
    d: "M264.588,68.852a.717.717,0,0,1,0,1.362,2.529,2.529,0,0,1-2.359,0,.717.717,0,0,1,0-1.362A2.529,2.529,0,0,1,264.588,68.852Z",
    transform: "translate(-261.737 -32.907)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2063_",
    d: "M267.138,67.382c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,267.138,67.382Z",
    transform: "translate(-258.087 -35.011)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2062_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(12.359 28.505)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2061_",
    d: "M290.069,68.871c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,290.069,68.871Z",
    transform: "translate(-225.26 -32.853)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2060_",
    d: "M292.609,67.4c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,292.609,67.4Z",
    transform: "translate(-221.624 -34.957)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2059_",
    d: "M300.239,63.012c.656.389.656,1,0,1.362a2.679,2.679,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,300.239,63.012Z",
    transform: "translate(-210.701 -41.267)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2058_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(92.869 17.878)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2057_",
    d: "M287.519,67.4a.717.717,0,0,1,0,1.362,2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,287.519,67.4Z",
    transform: "translate(-228.911 -34.957)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2056_",
    d: "M290.069,65.952c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,290.069,65.952Z",
    transform: "translate(-225.26 -37.058)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2055_",
    d: "M297.7,61.542c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0,.717.717,0,0,1,0-1.362A2.529,2.529,0,0,1,297.7,61.542Z",
    transform: "translate(-214.337 -43.372)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2054_",
    d: "M300.239,60.061c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,300.239,60.061Z",
    transform: "translate(-210.701 -45.465)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2053_",
    d: "M284.978,65.952c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,284.978,65.952Z",
    transform: "translate(-232.547 -37.058)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2052_",
    d: "M287.519,64.482c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,287.519,64.482Z",
    transform: "translate(-228.911 -39.163)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2051_",
    d: "M295.159,60.061c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,295.159,60.061Z",
    transform: "translate(-217.973 -45.465)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2050_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(80.492 10.729)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2049_",
    d: "M274.98,67.422a2.529,2.529,0,0,1,2.359,0,.717.717,0,0,1,0,1.362,2.529,2.529,0,0,1-2.359,0C274.323,68.394,274.323,67.787,274.98,67.422Z",
    transform: "translate(-243.484 -34.954)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2048_",
    d: "M279.888,65.952c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.656-.389-.656-1,0-1.362A2.529,2.529,0,0,1,279.888,65.952Z",
    transform: "translate(-239.834 -37.058)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2047_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(43.386 25.027)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2046_",
    d: "M284.978,63.012c.657.389.657,1,0,1.362a2.679,2.679,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,284.978,63.012Z",
    transform: "translate(-232.547 -41.267)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2045_",
    d: "M287.519,61.542c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0,.717.717,0,0,1,0-1.362A2.529,2.529,0,0,1,287.519,61.542Z",
    transform: "translate(-228.911 -43.372)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2044_",
    d: "M290.069,60.061c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,290.069,60.061Z",
    transform: "translate(-225.26 -45.465)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2043_",
    d: "M292.609,58.591c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,292.609,58.591Z",
    transform: "translate(-221.624 -47.57)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2042_",
    d: "M295.159,57.121c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,295.159,57.121Z",
    transform: "translate(-217.973 -49.674)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2041_",
    d: "M272.41,65.932a2.529,2.529,0,0,1,2.359,0,.717.717,0,0,1,0,1.362,2.529,2.529,0,0,1-2.359,0C271.753,66.929,271.753,66.321,272.41,65.932Z",
    transform: "translate(-247.164 -37.087)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2040_",
    d: "M277.319,64.451c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.656-.389-.656-1,0-1.362A2.679,2.679,0,0,1,277.319,64.451Z",
    transform: "translate(-243.513 -39.181)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2039_",
    d: "M279.868,62.981c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.679,2.679,0,0,1,279.868,62.981Z",
    transform: "translate(-239.863 -41.285)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2038_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(43.313 17.83)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2037_",
    d: "M284.958,60.062c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,284.958,60.062Z",
    transform: "translate(-232.576 -45.49)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2036_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(55.69 10.705)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2035_",
    d: "M290.038,57.122c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.656-.389-.656-1,0-1.362A2.529,2.529,0,0,1,290.038,57.122Z",
    transform: "translate(-225.303 -49.699)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2034_",
    d: "M292.589,55.652c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.656-.389-.656-1,0-1.362A2.529,2.529,0,0,1,292.589,55.652Z",
    transform: "translate(-221.653 -51.804)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2030_",
    d: "M269.87,64.462a2.529,2.529,0,0,1,2.359,0,.717.717,0,0,1,0,1.362,2.529,2.529,0,0,1-2.359,0C269.213,65.459,269.213,64.851,269.87,64.462Z",
    transform: "translate(-250.8 -39.191)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2029_",
    d: "M274.779,62.981c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.656-.389-.656-1,0-1.362A2.679,2.679,0,0,1,274.779,62.981Z",
    transform: "translate(-247.149 -41.285)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2028_",
    d: "M277.319,61.511c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.656-.389-.656-1,0-1.362A2.679,2.679,0,0,1,277.319,61.511Z",
    transform: "translate(-243.513 -43.39)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2027_",
    d: "M279.868,60.062c.657.389.657,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,279.868,60.062Z",
    transform: "translate(-239.863 -45.49)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2026_",
    d: "M282.409,58.592a.717.717,0,0,1,0,1.362,2.529,2.529,0,0,1-2.359,0c-.657-.389-.657-1,0-1.362A2.529,2.529,0,0,1,282.409,58.592Z",
    transform: "translate(-236.226 -47.595)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2025_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(49.514 7.131)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2024_",
    cx: 1.678,
    cy: 0.973,
    rx: 1.678,
    ry: 0.973,
    transform: "translate(55.69 3.556)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2023_",
    d: "M290.038,54.171c.656.389.656,1,0,1.362a2.529,2.529,0,0,1-2.359,0c-.656-.389-.656-1,0-1.362A2.679,2.679,0,0,1,290.038,54.171Z",
    transform: "translate(-225.303 -53.897)",
    fill: "#0c1859"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhattoexpect);
export default __webpack_public_path__ + "static/media/whattoexpect.3552a3a60398a427c805c400390185fa.svg";
export { ForwardRef as ReactComponent };